// extracted by mini-css-extract-plugin
module.exports = {"container":"index_container__CeReN","img":"index_img__4Z7u2","text":"index_text__FG2KG","rightIcon":"index_rightIcon__EnsLg"};